import { handleRequest } from "../utilities/requestHandler";

export const askChatbot = (req_body) => 
    handleRequest("post", "/chatbot/ask", req_body);